import React, { useEffect } from 'react';
import Container from '@atoms/Container';
import StepsBar from '@molecules/StepsBar';

import useCalculatorState from 'hooks/useCalculatorState';
import useGoToTop from 'hooks/useGoToTop';

import { CalculatorStep } from 'enums/calculator';
import Step1 from '@templates/Step1';
import Step2 from '@templates/Step2';
import Step3 from '@templates/Step3';
import Step4 from '@templates/Step4';
import Step5 from '@templates/Step5';

const IndexPage = () => {
  const containerRef = React.createRef<HTMLDivElement>();
  const {
    currentStep,
  } = useCalculatorState();
  const goTop = useGoToTop();

  useEffect(() => {
    goTop(true, containerRef.current);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [currentStep, goTop]);

  return (
    <section ref={containerRef}>
      <StepsBar />
      <Container className="mt-12 md:mt-24">
        { currentStep.id === CalculatorStep.UNIT_INFORMATION && <Step1 /> }
        { currentStep.id === CalculatorStep.PALLET_DATA && <Step2 /> }
        { currentStep.id === CalculatorStep.LAYER_CONFIGURATION && <Step3 /> }
        { currentStep.id === CalculatorStep.LAYER_ALIGNMENT && <Step4 /> }
        { currentStep.id === CalculatorStep.RESULTS && <Step5 /> }
      </Container>
    </section>
  );
};

export default IndexPage;
